import { TFunction } from 'i18next';
import { z } from 'zod';

import { translations } from 'locales/i18n';

export const entitlementGroupZodSchema = (t: TFunction<'translation', undefined>) =>
  z.object({
    id: z.number().optional(),
    name: z.string().min(1, t(translations.validation.required())),
    entitlements: z.array(z.object({ id: z.number() })).min(1, t(translations.validation.minOne()))
  });
